module.exports = __webpack_public_path__ + "img/homePage3.6a49bbeb.png";